import { type Dispatch, type SetStateAction, useEffect, useState } from "react";
import useEffectOnce from "./useEffectOnce";

export function useEventualState<T>(state: T): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(state);

  useEffect(() => {
    setValue(state);
  }, [state]);

  return [value, setValue];
}

export function useEventualStateOnce<T>(state: T): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(state);

  useEffectOnce(
    () => {
      setValue(state);
    },
    [state],
    state === undefined || state === null
  );

  return [value, setValue];
}

export function useEventualStateOnceTrue<T>(
  onceThisIsTrue: boolean,
  state: T
): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(state);

  useEffectOnce(
    () => {
      if (onceThisIsTrue) {
        setValue(state);
      }
    },
    [state, onceThisIsTrue],
    state === undefined || state === null || !onceThisIsTrue
  );

  return [value, setValue];
}
